export default "__VITE_ASSET__BFWbCEVR__"